import { useParamsContext } from '../../contexts/ParamsContext';
import { LembretesProvider } from './Context';
import LembretesForm from './form/Form';
import LembretesList from './list/List';

function LembretesContent() {
    const { action } = useParamsContext();

    switch (action) {
        case 'edit':
        case 'add':
            return <LembretesForm />;
        case 'list':
        default:
            return <LembretesList />;
    }
}

export default function Lembretes() {
    return (
        <LembretesProvider>
            <LembretesContent />
        </LembretesProvider>
    );
}
